/**
 * Conversation signal UI helpers (DB-backed catalog).
 * Source of truth: GET /chats/meta/conversation-signals/
 */

export interface ConversationSignalFilterColors {
  dot: string;
  bg: string;
  text: string;
  border: string;
}

export interface ConversationSignalUiEntry {
  key: string;
  label: string;
  description: string;
  category: string;
  filter: ConversationSignalFilterColors;
}

const DEFAULT_FILTER_COLORS: ConversationSignalFilterColors = {
  dot: '#9e9e9e',
  bg: '#f5f5f5',
  text: '#424242',
  border: '#e0e0e0',
};

export function buildConversationSignalUiMap(
  catalog: ConversationSignalUiEntry[] = []
): Record<string, ConversationSignalUiEntry> {
  const byKey: Record<string, ConversationSignalUiEntry> = {};
  for (const e of catalog) {
    if (!e?.key) continue;
    byKey[e.key] = e;
  }
  return byKey;
}

export function getConversationSignalUi(
  key: string,
  byKey?: Record<string, ConversationSignalUiEntry>
): ConversationSignalUiEntry | undefined {
  return byKey?.[key];
}

export function getFallbackSignalUi(key: string): ConversationSignalUiEntry {
  return {
    key,
    label: key,
    description: '',
    category: '',
    filter: DEFAULT_FILTER_COLORS,
  };
}
